const AthleteList = require('ffss/component/row/athlete/List');

class AthleteSearch{
    defaultOptions() {
        return {
            '$container': null,
            'urlDetail': '/competition/athlete/result',
            'urlClubDetail': '/competition/club/result'
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onClickNext = this.onClickNext.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
            window.notify("$container is missing in component/row/AthleteSearch","error");
        }

        this.$listContainer = $('.athlete-search-list',this.$container);
        this.$noResultContainer = $('.athlete-search-noresult',this.$container);

        this.$form = $('.athlete-search-form',this.$container);
        this.$resultContainer = $('.athlete-search-result-container',this.$container);
        this.$loader = $('.athlete-search-loader',this.$container);

        this.$filterSearch = $('input[name="search"]',this.$form);

        this.currentOffset = 0;
        this.currentRequest =  null;

        this.initialize();
    }


    initialize(){
        var self = this;

        this.$form.on('submit',this.onSubmit);
        this.$filterSearch.on('input',this.onFilterChange);

        this.list = new AthleteList({
            '$container': this.$listContainer,
            'onClickNext': this.onClickNext,
            'urlDetail': this.settings.urlDetail,
            'urlClubDetail': this.settings.urlClubDetail
        });

        if(this.canSubmit()){
            this.$form.trigger('submit');
        }
    }

    onFilterChange(event){
        let $filter = $(event.target);

        let filterName = $filter.attr('name');

        this.currentOffset = 0;
        if(this.canSubmit()){
            this.$form.trigger('submit');
        }
    }

    canSubmit(){
        let search = this.$filterSearch.val();

        return true;
    }

    onSubmit(event){
        event.preventDefault();
        event.stopPropagation();

        this.doSubmit(true);

    }

    getData(){
        let data = this.$form.serializeArray();

        data.push({
            'name': 'start',
            'value': this.currentOffset
        });
        return data;
    }

    doSubmit(clearList){
        var self = this;
        
        if(this.currentRequest != null){
            this.currentRequest.abort();
        }

        this.$resultContainer.show();
        this.$loader.show();
        this.$noResultContainer.hide();

        if(clearList){
            this.$listContainer.hide();
        }

        this.list.setNeedClear(clearList);

        let data = this.getData();

        this.currentRequest = $.ajax({
            'url': this.$form.attr('action'),
            'method': this.$form.attr('method'),
            'data': data
        })
        .done(function(xhr){
            if(xhr.success){
                let data = xhr.data;
                self.showResult(xhr);
            }else{
                window.notify("todo notification of error : "+ xhr.message,"error");
            }
        })
        .fail(function(){
            window.notify("todo notification of error","error");
        })
        .always(function(){
            self.$loader.hide();
        });

    }

    showResult(xhr){
        if(xhr.data.length == 0){
            this.$noResultContainer.show();
        }else{
            this.fillListWithResult(xhr);
            this.$listContainer.show();
        }
    }

    fillListWithResult(data){
        this.list.setData(data);
    }

    onClickNext(offset){
        this.currentOffset = offset;

        this.doSubmit(false);
    }

}

module.exports = AthleteSearch;